import L from 'leaflet';
import { Moment } from 'moment';
export type LeafletFnWrapper = (lat: number, long: number) => void;


// export type LeafletFnWrapper = (latlng: L.LatLngExpression, options?: L.PanOptions | undefined) => L.Map;

export interface DevAppContext {
    mapContext?: React.MutableRefObject<L.Map|undefined>
    setMapContext: (map: L.Map) => void,
    selectedProvider?: ProviderDto,
    setSelectedProvider: (provider: any) => void,
    providers?: PagedList<ProviderDto>|undefined,
    setProviders: (provider: PagedList<ProviderDto>) => void,
    showLoading: boolean,
    setShowLoading: (loading: boolean) => void,
    providerSearchParams?: ProviderSearchParamsDto,
    setProviderSearchParams: (params: ProviderSearchParamsDto) => void,
    providerAuxiliaryData?: ProviderAuxiliaryDataDto,
    setProviderAuxiliaryData: (value: ProviderAuxiliaryDataDto|undefined) => void
}

export interface Schedule {
    scheduleId: string,
    mondayStart: Date|null,
    mondayEnd: Date|null,
    tuesdayStart: Date|null,
    tuesdayEnd: Date|null,
    wednesdayStart: Date|null,
    wednesdayEnd: Date|null,
    thursdayStart: Date|null,
    thursdayEnd: Date|null,
    fridayStart: Date|null,
    fridayEnd: Date|null,
    saturdayStart: Date|null,
    saturdayEnd: Date|null,
    sundayStart: Date|null,
    sundayEnd: Date|null,
    breakTime: string,
}

export interface VaccineDto {
    vaccineId: string,
    name: string,
    available: boolean,
    order: number
}

export interface ProviderDto {

    providerId: string,
    name: string,
    address: string,
    municipalityId: string,
    municipalityName: string,
    latitude: number,
    longitude: number,
    phone: string,
    ext: string,
    altPhone: string,
    altExt: string,
    email: string,
    organizationTypeId: string,
    organizationName: string,
    healthCenterTypeId: string,
    healthCenterName: string,
    medicalPracticeTypeId: string,
    medicalPracticeName: string,
    farmacyTypeId: string,
    farmacyName: string,
    publicHealthProviderTypeId: string,
    publicHealthProviderName: string,
    longTermCareTypeId: string,
    longTermCareName: string,
    otherOrganization: string|null,
    otherMedicalPractice: string|null,
    schedule: Schedule,
    otherCoordinationMethod: string|null,  
    pediatricNote: string|null,
    otherAdditionalService: string|null,
    mobileClinicCount: number|null,
    otherAccessibilityCriteria: string|null,
    otherServiceLanguage: string|null,
    otherVaccine: string|null,
    parkingHasCost: boolean|null,
    vaccines: VaccineDto[],
    isOpen: boolean
}

export interface ProviderAuxiliaryDataDto {
    appointmentCoordinationMethods: string[],
    additionalServices: string[],
    populations: string[],
    accessibilityCriteria: string[],
    serviceLangs: string[],
    hasParking: boolean,
    hasMobileClinic: boolean
}

export interface PopulationTypeDto {
    populationTypeId: string,
    name: string,
    order: number
}

export interface ProviderSearchParamsDto {
    name?: string|null,
    municipalityId?: number|null,
    vaccines?: string[]|null,
    populations?: string[]|null,
    startTime?: Date|null,
    endTime?: Date|null,
    pageNumber?: number|null,
    pageSize?: number|null
}

export interface PagedList<T> {
    items: T[],
    pageSize: number,
    pageNumber: number,
    total: number
}

export interface DevApiResult<T> {
    data: T,
    error: Error
}


// Routes
export const GET_PROVIDERS = "api/provider";
export const GET_ALL_PROVIDERS = "api/providers/all";
export const GET_ALL_VACCINES = "api/filter/vaccines";
export const GET_ALL_POPULATION_TYPES = "api/filter/populations";


export const municipalities = [
    {
        "municipalityId": 1,
        "name": "Adjuntas"
    },
    {
        "municipalityId": 2,
        "name": "Aguada"
    },
    {
        "municipalityId": 3,
        "name": "Aguadilla"
    },
    {
        "municipalityId": 4,
        "name": "Aguas Buenas"
    },
    {
        "municipalityId": 5,
        "name": "Aibonito"
    },
    {
        "municipalityId": 6,
        "name": "Añasco"
    },
    {
        "municipalityId": 7,
        "name": "Arecibo"
    },
    {
        "municipalityId": 8,
        "name": "Arroyo"
    },
    {
        "municipalityId": 9,
        "name": "Barceloneta"
    },
    {
        "municipalityId": 10,
        "name": "Barranquitas"
    },
    {
        "municipalityId": 11,
        "name": "Bayamón"
    },
    {
        "municipalityId": 12,
        "name": "Cabo Rojo"
    },
    {
        "municipalityId": 13,
        "name": "Caguas"
    },
    {
        "municipalityId": 14,
        "name": "Camuy"
    },
    {
        "municipalityId": 15,
        "name": "Canóvanas"
    },
    {
        "municipalityId": 16,
        "name": "Carolina"
    },
    {
        "municipalityId": 17,
        "name": "Cataño"
    },
    {
        "municipalityId": 18,
        "name": "Cayey"
    },
    {
        "municipalityId": 19,
        "name": "Ceiba"
    },
    {
        "municipalityId": 20,
        "name": "Ciales"
    },
    {
        "municipalityId": 21,
        "name": "Cidra"
    },
    {
        "municipalityId": 22,
        "name": "Coamo"
    },
    {
        "municipalityId": 23,
        "name": "Comerío"
    },
    {
        "municipalityId": 24,
        "name": "Corozal"
    },
    {
        "municipalityId": 25,
        "name": "Culebra"
    },
    {
        "municipalityId": 26,
        "name": "Dorado"
    },
    {
        "municipalityId": 27,
        "name": "Fajardo"
    },
    {
        "municipalityId": 28,
        "name": "Florida"
    },
    {
        "municipalityId": 29,
        "name": "Guánica"
    },
    {
        "municipalityId": 30,
        "name": "Guayama"
    },
    {
        "municipalityId": 31,
        "name": "Guayanilla"
    },
    {
        "municipalityId": 32,
        "name": "Guaynabo"
    },
    {
        "municipalityId": 33,
        "name": "Gurabo"
    },
    {
        "municipalityId": 34,
        "name": "Hatillo"
    },
    {
        "municipalityId": 35,
        "name": "Hormigueros"
    },
    {
        "municipalityId": 36,
        "name": "Humacao"
    },
    {
        "municipalityId": 37,
        "name": "Isabela"
    },
    {
        "municipalityId": 38,
        "name": "Jayuya"
    },
    {
        "municipalityId": 39,
        "name": "Juana Díaz"
    },
    {
        "municipalityId": 40,
        "name": "Juncos"
    },
    {
        "municipalityId": 41,
        "name": "Lajas"
    },
    {
        "municipalityId": 42,
        "name": "Lares"
    },
    {
        "municipalityId": 43,
        "name": "Las Marías"
    },
    {
        "municipalityId": 44,
        "name": "Las Piedras"
    },
    {
        "municipalityId": 45,
        "name": "Loíza"
    },
    {
        "municipalityId": 46,
        "name": "Luquillo"
    },
    {
        "municipalityId": 47,
        "name": "Manatí"
    },
    {
        "municipalityId": 48,
        "name": "Maricao"
    },
    {
        "municipalityId": 49,
        "name": "Maunabo"
    },
    {
        "municipalityId": 50,
        "name": "Mayagüez"
    },
    {
        "municipalityId": 51,
        "name": "Moca"
    },
    {
        "municipalityId": 52,
        "name": "Morovis"
    },
    {
        "municipalityId": 53,
        "name": "Naguabo"
    },
    {
        "municipalityId": 54,
        "name": "Naranjito"
    },
    {
        "municipalityId": 55,
        "name": "Orocovis"
    },
    {
        "municipalityId": 56,
        "name": "Patillas"
    },
    {
        "municipalityId": 57,
        "name": "Peñuelas"
    },
    {
        "municipalityId": 58,
        "name": "Ponce"
    },
    {
        "municipalityId": 59,
        "name": "Quebradillas"
    },
    {
        "municipalityId": 60,
        "name": "Rincón"
    },
    {
        "municipalityId": 61,
        "name": "Río Grande"
    },
    {
        "municipalityId": 62,
        "name": "Sabana Grande"
    },
    {
        "municipalityId": 63,
        "name": "Salinas"
    },
    {
        "municipalityId": 64,
        "name": "San Germán"
    },
    {
        "municipalityId": 65,
        "name": "San Juan"
    },
    {
        "municipalityId": 66,
        "name": "San Lorenzo"
    },
    {
        "municipalityId": 67,
        "name": "San Sebastián"
    },
    {
        "municipalityId": 68,
        "name": "Santa Isabel"
    },
    {
        "municipalityId": 69,
        "name": "Toa Alta"
    },
    {
        "municipalityId": 70,
        "name": "Toa Baja"
    },
    {
        "municipalityId": 71,
        "name": "Trujillo Alto"
    },
    {
        "municipalityId": 72,
        "name": "Utuado"
    },
    {
        "municipalityId": 73,
        "name": "Vega Alta"
    },
    {
        "municipalityId": 74,
        "name": "Vega Baja"
    },
    {
        "municipalityId": 75,
        "name": "Vieques"
    },
    {
        "municipalityId": 76,
        "name": "Villalba"
    },
    {
        "municipalityId": 77,
        "name": "Yabucoa"
    },
    {
        "municipalityId": 78,
        "name": "Yauco"
    }
]